<template>
	<div></div>
</template>

<script>
	import { MP } from '../../assets/js/map.js'
	export default {
		name: "get-position",
		data() {
			return {
				ak: "F1FaVpdBpLrjBIiYCjbnbG0BFgYfnEdo"
			}
		},
		mounted() {
			var _this = this;
			MP(_this.ak).then(BMap => {
				var myCity = new BMap.LocalCity();
				myCity.get(function(result){
					_this.$store.commit("setNowAdd", result.name);	
					_this.$emit("getPosition",result)
					if(window.localStorage){
						localStorage.setItem("yushuiyuanadd",result.name);
					}else{
					    document.cookie = "yushuiyuanadd="+result.name;
					}
				})
			})
		},
		created(){
			var _this = this;
			MP(_this.ak).then(BMap => {
				var myCity = new BMap.LocalCity();
				myCity.get(function(result){
					_this.$store.commit("setNowAdd", result.name);	
					_this.$emit("getPosition",result)
				})
			})
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Common/GetPosition.vue